import React from 'react';
import { PriceString, Radio } from '@fourthwall/components';
import * as S from './PlanOption.styled';
export const PlanOption = ({ plan, selected, onClick }) => {
    return (React.createElement(S.Container, { selected: selected, onClick: onClick },
        React.createElement(S.RadioContainer, null,
            React.createElement(Radio, { checked: selected })),
        React.createElement(S.Content, null,
            React.createElement(S.Label, null, plan.label),
            React.createElement(S.Text, null,
                React.createElement(PriceString, { ...plan.monthlyPrice }),
                " per month"),
            plan.savings && (React.createElement(S.SavingsTag, null,
                "Save ",
                React.createElement(PriceString, { ...plan.savings }))))));
};
